import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

const BASE_URL = `${BEPI_API.admin}/home`;

export const AdminHomeApi = {
  getHomeData: () => axios.get(`${BASE_URL}/dashboard`),

  getHomeDataByStatus: (status) => axios.get(`${BASE_URL}/status/${status}/`),

  // Buscar equipamento por ID
  searchEquipment: (_equipmentId) => Promise.reject(
    // TODO: INEXISTENTE no backend: /web/admin/equipment/{id}
    new Error('Endpoint de busca de equipamento indisponivel no backend atual.')
  ),

  refreshHomeData: () => axios.get(`${BASE_URL}/refresh/`),

  assumeQuotation: (payload) => axios.post(`${BASE_URL}/quotations/assume`, payload),

  unassignCommercialQuotation: (payload) => axios.post(`${BASE_URL}/quotations/unassign`, payload),

  unassignWorkshopQuotation: (payload) => axios.post(`${BASE_URL}/quotations/unassign-workshop`, payload),

  updateQuotationStatus: (id, status) => axios.put(`${BASE_URL}/quotations/${id}/status`, { status }),
};

